
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/italian-stories/[...slug]",
      function () {
        return require("private-next-pages/italian-stories/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/italian-stories/[...slug]"])
      });
    }
  